import type { Lang } from '@bia-auction/shared-i18n';
import { api } from './api';

/**
 * Persist the caller's notification locale to the server (M8), with bounded exponential-backoff
 * retry so a transient network error / 429 / 5xx doesn't leave the server locale diverged from the
 * chosen UI language. Best-effort and fire-and-forget; anonymous callers should not invoke it.
 * Used both by the language switcher (on change) and the shell (on login, to flush a language the
 * visitor picked while logged out).
 */
export async function persistLocale(locale: Lang): Promise<void> {
  for (let attempt = 0; attempt < 4; attempt++) {
    try {
      await api('/me/locale', { method: 'PUT', body: { locale } });
      return;
    } catch {
      if (attempt < 3) await new Promise((r) => setTimeout(r, 1_000 * 2 ** attempt));
    }
  }
}
